import React, { Fragment, useEffect } from 'react';
import moment from 'moment';
import _ from 'underscore';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import jwt from 'jwt-decode';
import config from 'configuration/configuration.js';

import useRouter from 'utils/useRouter';

import { RedirectToError } from 'actions';

// Example of user roles: ['GUEST', 'USER', 'ADMIN'];

const AuthGuard = (props) => {
	const { roles, children, operators, projects } = props;
	const loggedIn = useSelector((state) => state.session.loggedIn);
	const link = useSelector((state) => state.session.link);
	const user = useSelector((state) => state.session.user);
	const router = useRouter();
	const dispatch = useDispatch();
	const { history } = router;
	const token = localStorage.getItem(config.TOKEN_KEY);

	useEffect(() => {
		if (token) {
			const decoded = jwt(token);
			// const currentDate = moment().add(1, 'year').toDate().getTime() / 1000;
			const currentDate = new Date().getTime() / 1000;
			if (decoded.exp < currentDate) {
				history.push('/auth/login');
				return;
			}
		} else {
			history.push('/auth/login');
			return;
		}

		if (!loggedIn || !user) {
			history.push('/auth/login');
			return;
		}

		if (link) {
			dispatch(RedirectToError());
			history.push(link);
			return;
		}

		if ((roles && !roles.includes(user.role)) || (operators && !operators.includes(user.operator)) || (projects && user.projects && _.intersection(projects, user.projects).length === 0)) {
			history.push('/errors/error-401');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [router]);

	return <>{children}</>;
};

AuthGuard.propTypes = {
	children: PropTypes.node,
	roles: PropTypes.array.isRequired,
	operators: PropTypes.array,
	projects: PropTypes.array,
};

export default AuthGuard;
